import script from "./BannerPicture.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerPicture.vue?vue&type=script&setup=true&lang=js"

import "./BannerPicture.vue?vue&type=style&index=0&id=23789ff8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23789ff8"]])

export default __exports__